
import { Button } from '@/components/ui/button';
import { Loader2, ArrowLeft, ArrowRight, Save } from 'lucide-react';

interface ApplicationControlsProps {
  currentSection: number;
  totalSections: number;
  onPrevious: () => void;
  onNext: () => void;
  onSave: () => Promise<void>;
  isLoading?: boolean;
}

export const ApplicationControls = ({
  currentSection,
  totalSections,
  onPrevious,
  onNext,
  onSave,
  isLoading,
}: ApplicationControlsProps) => {
  const isLastSection = currentSection === totalSections - 1;
  const isPEOPreferences = currentSection === totalSections - 2;

  const handleSaveAndContinue = async () => {
    await onSave();
    onNext();
  };

  return (
    <div className="flex flex-wrap gap-3 justify-between items-center mt-6 sm:mt-8 bg-white/50 backdrop-blur-sm p-4 rounded-lg border border-white/20 shadow-sm">
      <Button
        variant="outline"
        onClick={onPrevious}
        disabled={currentSection === 0 || isLoading}
        className="text-sm h-9 px-3 sm:h-10 sm:px-4 hover:bg-gray-100"
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Previous
      </Button>

      <div className="flex gap-3">
        {!isLastSection && (
          <Button
            onClick={handleSaveAndContinue}
            disabled={isLoading}
            className="text-sm h-9 px-3 sm:h-10 sm:px-4 relative overflow-hidden group"
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Saving...
              </>
            ) : (
              <>
                Save & Continue
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                <span className="absolute inset-0 w-full h-full bg-gradient-shimmer -translate-x-full group-hover:translate-x-full transition-transform duration-1000 opacity-20"></span>
              </>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};
